

    // let isLocked    = false;
    // let autoplayTimer  = null;
    // let exitTimer      = null;  // <-- nuovo
    // let progressTimer  = null;

    // const DEFAULT_DURATION = 8000;
    // const EXIT_DURATION    = 1000; // deve combaciare con la transition CSS del testo


    // const swiper = new Swiper('.n-hero-slider', {
    //     loop: true,
    //     speed: 800,

    //     on: {
    //         init(swiper) {
    //             setupSlide(swiper);
    //             startSlide(swiper);
    //         },

    //         slideChangeTransitionStart(swiper) {
    //             startSlide(swiper);
    //         },

    //         slideChangeTransitionEnd(swiper) {
    //             setupSlide(swiper);
    //         }
    //     }
    // });

    // const nextBtn = document.querySelector('#n_hero_next');
    // const prevBtn = document.querySelector('#n_hero_prev');

    // nextBtn.addEventListener('click', () => change('next'));
    // prevBtn.addEventListener('click', () => change('prev'));

    // // ── Cambio manuale ────────────────────────────────────────────────────────

    // function change(dir) {

    //     if (isLocked) return;
    //     isLocked = true;

    //     // Cancella i timer automatici — l'utente ha già deciso
    //     clearTimeout(autoplayTimer);
    //     clearTimeout(exitTimer);
    //     cancelAnimationFrame(progressTimer);

    //     const current = swiper.slides[swiper.activeIndex];
    //     current.classList.add('n-slide-leaving');

    //     const content = current.querySelector('.n-hero-content');

    //     const onEnd = (e) => {
    //         if (e.propertyName !== 'opacity') return;
    //         content.removeEventListener('transitionend', onEnd);
    //         dir === 'next' ? swiper.slideNext() : swiper.slidePrev();
    //     };

    //     content.addEventListener('transitionend', onEnd);
    // }

    // // ── Setup classi slide ────────────────────────────────────────────────────

    // function setupSlide(swiper) {

    //     swiper.slides.forEach(s => {
    //         s.classList.remove('n-slide-active', 'n-slide-leaving');
    //     });

    //     swiper.slides[swiper.activeIndex].classList.add('n-slide-active');

    //     isLocked = false;
    // }

    // // ── Avvia media + timer ───────────────────────────────────────────────────

    // function startSlide(swiper) {

    //     const slide = swiper.slides[swiper.activeIndex];
    //     const video = slide.querySelector('video');

    //     let duration = DEFAULT_DURATION;

    //     if (video) {
    //         video.currentTime = 0;
    //         video.play().catch(() => {});
    //         if (video.duration && !isNaN(video.duration)) {
    //             duration = video.duration * 1000;
    //         }
    //     }

    //     startProgress(duration);
    //     scheduleAutoplay(duration);
    // }

    // // ── Autoplay: anticipa uscita testo, poi cambia slide ────────────────────

    // function scheduleAutoplay(duration) {

    //     clearTimeout(autoplayTimer);
    //     clearTimeout(exitTimer);

    //     const exitAt = Math.max(0, duration - EXIT_DURATION);

    //     // Anticipa: aggiunge n-slide-leaving EXIT_DURATION ms prima
    //     exitTimer = setTimeout(() => {
    //         const active = swiper.slides[swiper.activeIndex];
    //         if (active) active.classList.add('n-slide-leaving');
    //     }, exitAt);

    //     // Poi cambia slide
    //     autoplayTimer = setTimeout(() => {
    //         swiper.slideNext();
    //     }, duration);
    // }

    // // ── Progress bar ─────────────────────────────────────────────────────────

    // function startProgress(duration) {

    //     const bar = document.querySelector('.n-hero-bar-len');
    //     if (!bar) return;

    //     cancelAnimationFrame(progressTimer);

    //     bar.style.width = '0%';
    //     const start = performance.now();

    //     function animate(now) {
    //         const p = Math.min((now - start) / duration, 1);
    //         bar.style.width = `${p * 100}%`;
    //         if (p < 1) progressTimer = requestAnimationFrame(animate);
    //     }

    //     progressTimer = requestAnimationFrame(animate);
    // }




let isLocked    = false;
    let autoplayTimer  = null;
    let exitTimer      = null;
    let progressTimer  = null;
    let isSingleSlide  = false;

    const DEFAULT_DURATION = 8000;
    const EXIT_DURATION    = 1000; // deve combaciare con la transition CSS del testo

    const swiper = new Swiper('.n-hero-slider', {
        loop: true,
        speed: 800,

        on: {
            init(swiper) {
                isSingleSlide = [...swiper.slides]
                    .filter(s => !s.classList.contains('swiper-slide-duplicate')).length === 1;

                setupSlide(swiper);

                if (isSingleSlide) {
                    startSingleSlide(swiper);
                    return;
                }

                startSlide(swiper);
            },

            slideChangeTransitionStart(swiper) {
                if (isSingleSlide) return;
                startSlide(swiper);
            },

            slideChangeTransitionEnd(swiper) {
                if (isSingleSlide) return;
                setupSlide(swiper);
            }
        }
    });

    // ── Navigazione manuale (i bottoni esistono nel DOM solo con più slide) ──

    const nextBtn = document.querySelector('#n_hero_next');
    const prevBtn = document.querySelector('#n_hero_prev');

    if (nextBtn) nextBtn.addEventListener('click', () => change('next'));
    if (prevBtn) prevBtn.addEventListener('click', () => change('prev'));

    // ── Singola slide ─────────────────────────────────────────────────────────

    function startSingleSlide(swiper) {
        const slide = swiper.slides[swiper.activeIndex];
        const video = slide.querySelector('video');

        if (video) {
            video.currentTime = 0;
            video.play().catch(() => {});
        }
    }

    // ── Cambio manuale ────────────────────────────────────────────────────────

    function change(dir) {

        if (isLocked) return;
        isLocked = true;

        clearTimeout(autoplayTimer);
        clearTimeout(exitTimer);
        cancelAnimationFrame(progressTimer);

        const current = swiper.slides[swiper.activeIndex];
        current.classList.add('n-slide-leaving');

        const content = current.querySelector('.n-hero-content');

        const onEnd = (e) => {
            if (e.propertyName !== 'opacity') return;
            content.removeEventListener('transitionend', onEnd);
            dir === 'next' ? swiper.slideNext() : swiper.slidePrev();
        };

        content.addEventListener('transitionend', onEnd);
    }

    // ── Setup classi slide ────────────────────────────────────────────────────

    function setupSlide(swiper) {

        swiper.slides.forEach(s => {
            s.classList.remove('n-slide-active', 'n-slide-leaving');
        });

        swiper.slides[swiper.activeIndex].classList.add('n-slide-active');

        isLocked = false;
    }

    // ── Avvia media + timer ───────────────────────────────────────────────────

    function startSlide(swiper) {

        const slide = swiper.slides[swiper.activeIndex];
        const video = slide.querySelector('video');

        if (video) {
            video.currentTime = 0;
            video.play().catch(() => {});

            // Se la durata è già nota (slide già visitata o metadati precaricati) partiamo subito.
            // Altrimenti aspettiamo loadedmetadata prima di avviare i timer,
            // così la durata reale del video viene sempre rispettata.
            if (video.duration && !isNaN(video.duration)) {
                startProgress(video.duration * 1000);
                scheduleAutoplay(video.duration * 1000);
            } else {
                // Partiamo con DEFAULT_DURATION come fallback visivo,
                // poi aggiorniamo non appena i metadati sono disponibili.
                startProgress(DEFAULT_DURATION);
                scheduleAutoplay(DEFAULT_DURATION);

                video.addEventListener('loadedmetadata', function onMeta() {
                    video.removeEventListener('loadedmetadata', onMeta);

                    // Aggiorniamo solo se questa slide è ancora quella attiva
                    if (swiper.slides[swiper.activeIndex] !== slide) return;

                    const duration = video.duration * 1000;
                    startProgress(duration);
                    scheduleAutoplay(duration);
                });
            }
        } else {
            startProgress(DEFAULT_DURATION);
            scheduleAutoplay(DEFAULT_DURATION);
        }
    }

    // ── Autoplay: anticipa uscita testo, poi cambia slide ────────────────────

    function scheduleAutoplay(duration) {

        clearTimeout(autoplayTimer);
        clearTimeout(exitTimer);

        const exitAt = Math.max(0, duration - EXIT_DURATION);

        exitTimer = setTimeout(() => {
            const active = swiper.slides[swiper.activeIndex];
            if (active) active.classList.add('n-slide-leaving');
        }, exitAt);

        autoplayTimer = setTimeout(() => {
            swiper.slideNext();
        }, duration);
    }

    // ── Progress bar ─────────────────────────────────────────────────────────

    function startProgress(duration) {

        const bar = document.querySelector('.n-hero-bar-len');
        if (!bar) return;

        cancelAnimationFrame(progressTimer);

        bar.style.width = '0%';
        const start = performance.now();

        function animate(now) {
            const p = Math.min((now - start) / duration, 1);
            bar.style.width = `${p * 100}%`;
            if (p < 1) progressTimer = requestAnimationFrame(animate);
        }

        progressTimer = requestAnimationFrame(animate);
    }